import * as React from 'react';

import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps,
  numberInputClasses,
} from '@mui/base/Unstable_NumberInput';
import { Box } from '@mui/material';
import { styled } from '@mui/system';

export default function CustomNumberInput(props: NumberInputProps) {
  return (
    <BaseNumberInput
      slots={{
        root: InputRoot,
        input: InputElement,
        incrementButton: Hidden,
        decrementButton: Hidden,
      }}
      {...props}
    />
  );
}

export const CustomInputAdornment = styled(Box)`
  margin: 8px;
  align-items: center;
  justify-content: center;
  grid-row: 1/3;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const InputRoot = styled(Box)`
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.text.secondary};
  box-sizing: border-box;
  display: flex;
  min-width: 0;
  width: 100%;
  /* overflow: hidden; */

  &:hover {
    border-color: ${({ theme }) => theme.palette.text.primary};
  }

  &.${numberInputClasses.focused} {
    border-color: ${({ theme }) => theme.palette.primary.dark};
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`;

const InputElement = styled('input')`
  font-size: 1rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.5;
  grid-row: 1/3;
  background: inherit;
  border: none;
  border-radius: inherit;
  min-width: 0;
  padding: 8px 12px;
  outline: 0;
  width: 100%;
`;

const Hidden = styled('div')`
  display: none;
`;
